__turbopack_context__.v({
  "carListName": "qgvzVW_carListName",
  "carSelectedSheetCategoryHintText": "qgvzVW_carSelectedSheetCategoryHintText",
  "carSelectedSheetCategoryText": "qgvzVW_carSelectedSheetCategoryText",
  "carSelectedSheetContent": "qgvzVW_carSelectedSheetContent",
  "carSelectedSheetTrailing": "qgvzVW_carSelectedSheetTrailing",
  "carSelectedSheetTriggerContent": "qgvzVW_carSelectedSheetTriggerContent",
  "carSheetContent": "qgvzVW_carSheetContent",
});
